import $ from 'jquery'
import SmoothScrollTo from 'flamingo-carotene-smooth-scroll-to'

export default class scrollToError {
  constructor(element) {
    this.$element = $(element)
    new SmoothScrollTo().scrollTo(this.$element.get(0))
  }
}